import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { appRoutes } from "../../../routes/routes";
import AppConfigService from "../../../service/app_config/AppConfigService";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import {
  deviceInfo,
  getIPLocation,
} from "../../../service/device_info/DeviceInfo";
import { getFCMToken } from "../../../service/firebase/Firebase";
import ShowToast from "../../../widget/common/ui/Toast";

const APP_DEFAULT_TOKEN =
  process.env.REACT_APP_token_default ?? "030723553bff7";

const OnboardingProvider = new (class OnboardingProvider {
  init = async (companyCode: string) => {
    const companyId: string = AppConfigService.get("company_id");
    const apiToken: string = CacheStorage.getValue(StorageKeys.api_token);

    if (
      UtilityHelper.isEmpty(apiToken) &&
      UtilityHelper.isNotEmpty(companyId)
    ) {
      this.registerDevice(companyCode);
    }
  };

  registerDevice = async (companyCode: string) => {
    ApiUrls.init();

    let FCMToken: string = CacheStorage.getValue(StorageKeys.device_token);
    if (UtilityHelper.isEmpty(FCMToken)) {
      FCMToken = await getFCMToken();
    }

    let webIpInfo = CacheStorage.getValue(StorageKeys.web_ip_info);
    if (UtilityHelper.isEmpty(webIpInfo)) {
      await getIPLocation();
    }

    let webId = "";
    webIpInfo = CacheStorage.getValue(StorageKeys.web_ip_info);
    if (UtilityHelper.isNotEmpty(webIpInfo)) {
      webId = JSON.parse(webIpInfo)["ip"] ?? "";
    }

    const deviceId: string = `${deviceInfo.uiId}|${webId}|${deviceInfo.platform}`;
    const deviceName: string = deviceInfo.userAgent;
    const devicePlatform: string = "4"; // web
    const deviceType: string = "0"; // web
    const deviceToken: string = FCMToken;

    const url: string = `${ApiUrls.baseUrl}device/register_device`;
    const body: any = {
      api_token: APP_DEFAULT_TOKEN.toString(),
      device_id: deviceId,
      device_name: deviceName,
      device_platform: devicePlatform,
      device_type: deviceType,
      fcm_token: deviceToken,
      device_version: "1.0.0",
    };
    const response: any = await ApiService.postApi(url, body, true);
    if (response != null) {
      if (response["success"] === "1") {
        CacheStorage.saveValue(StorageKeys.device_id, deviceId);

        CacheStorage.saveValue(
          StorageKeys.app_id,
          response["result"]["device_details"]["app_id"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.api_token,
          response["result"]["device_details"]["api_token"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.refresh_token,
          response["result"]["device_details"]["refresh_token"].toString()
        );
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }
  };

  refreshToken = async () => {
    console.log(`refreshToken`);
    ApiUrls.init();

    const refreshToken: string =
      CacheStorage.getValue(StorageKeys.refresh_token) || "";
    const deviceId: string = CacheStorage.getValue(StorageKeys.device_id);
    const appId: string = CacheStorage.getValue(StorageKeys.app_id);

    const url: string = `${ApiUrls.baseUrl}device/refresh_device_token`;
    const body: any = {
      api_token: refreshToken,
      app_id: appId,
      device_id: deviceId,
    };
    const response: any = await ApiService.postApi(url, body, true);
    if (response != null) {
      if (response["success"] === "1") {
        CacheStorage.saveValue(StorageKeys.device_id, deviceId);

        CacheStorage.saveValue(
          StorageKeys.app_id,
          response["result"]["device_details"]["app_id"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.api_token,
          response["result"]["device_details"]["api_token"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.refresh_token,
          response["result"]["device_details"]["refresh_token"].toString()
        );
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }
  };

  launchLogic = (companyCode: string) => {
    const loginStatus: string =
      CacheStorage.getValue(StorageKeys.login_status) || "0";

    let newRouteName = "";
    if (loginStatus === "1") {
      //navigate(appRoutes.routeNameHome, { replace: true });
      newRouteName = UtilityHelper.getLastArrayStringValue(
        appRoutes.routeNameHome
      ); //appRoutes.routeNameHome.replaceAll("/undefined", "");
      window.location.replace(`/${companyCode}/${newRouteName}`);
    } else {
      //navigate(appRoutes.routeNameLogin, { replace: true });
      newRouteName = UtilityHelper.getLastArrayStringValue(
        appRoutes.routeNameLogin
      ); //newRouteName = appRoutes.routeNameLogin.replaceAll("/undefined", "");
      window.location.replace(`/${companyCode}/${newRouteName}`);
    }
  };
})();

export default OnboardingProvider;
